import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  GEOCODING_REVERSE_URI,
  MIN_SPEED_THING_FLEX,
  THING_FIND_URI,
  THING_UPDATE_URI
} from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'
import dayjs from 'dayjs'

export default {
  getThingsList({ projection, page } = { projection: null, page: null }) {
    return new Promise((resolve, reject) => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(resolve, RACE_TIMEOUT, [])
      })
      // thingsListRace is a async function that fetch the person list
      const p2 = this.thingsListRace(projection, page)
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          resolve(error)
        })
    })
  },

  thingsListRace(projection, page) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [connectionService.getAccountId()]
      const kwArgs = connectionService.createkwArgs()
      console.log('kwArgs',kwArgs)
      const options = {}
      kwArgs.types = ['mrn:thing:vehicle', 'mrn:thing:flex']
      kwArgs.query_spec = {
        _p: Boolean(projection)
          ? projection
          : 'account_id,' +
            'id,' +
            'type,' +
            'info,' +
            'config,' +
            'created_timestamp,' +
            'things,' +
            'metadata.reported_state.location,' +
            'metadata.reported_state.speed,' +
            'metadata.reported_state.signal_sensors,' +
            'reported_state.speed,' +
            'reported_state.location,' +
            'reported_state.heading,' +
            'reported_state.fuel_cut_off,' +
            'reported_state.signal_sensors,' +
            'reported_state.main_power_on,' +
            'reported_state.battery_level,' +
            'reported_state.contact_on,' +
            'reported_state.telemetry,' +
            'reported_state.ignition_status,' +
            'reported_state.ibutton,' +
            'is_alias,' +
            'aliases_qty',
            _page: page
            //_limit: 200
      }
      connection.session.call(THING_FIND_URI, args, kwArgs, options).then(
        response => {
          console.log("Success Things Response=",response)
          resolve(response)
        },
        wampError => {
          console.error("Error Things Response=",response)
          reject(wampError)
        }
      )
    })
  },

  getThingType(thing) {
    const input = thing
    const fields = input.type.split(':')
    const type = fields[2]
    return type
  },
  //Marca
  getThingMake(thing) {
    const make = thing.info.make
    return make
  },
  //Modelo
  getThingModel(thing) {
    const model = thing.info.model
    return model
  },
  //Año
  getThingYear(thing) {
    const year = thing.info.year
    return year
  },
  //Color
  getThingColor(thing) {
    const color = thing.info.color
    return color
  },
  //Chasis
  getThingChasisNumber(thing) {
    const chasisNumber = thing.info.chassis_number
    return chasisNumber
  },
  //Motor
  getThingEngineNumber(thing) {
    const engineNumber = thing.info.engine_number
    return engineNumber
  },
  getThingDomain(thing) {
    const type = this.getThingType(thing)
    let domain
    switch (type) {
      case 'vehicle':
        domain = thing.info.domain
        break
      case 'flex':
        domain = this.getGpsId(thing)
        break
      default:
        break
    }
    return domain
  },
  getGpsId(thing) {
    const hasGps = thing.hasOwnProperty('things')
    if (hasGps) {
      const index = thing.things[0].indexOf('-')
      const sliceGpsId = thing.things[0].slice(index + 1)
      return sliceGpsId
    } else {
      return ''
    }
  },
  getThingStatus(type, data) {
    let status = ''
    if (type == 'vehicle') {
      switch (data.contact_on) {
        case true:
          data.speed > MIN_SPEED_THING_VEHICLE ? (status = 'moving') : ''
          data.speed <= MIN_SPEED_THING_VEHICLE ? (status = 'on') : ''

          break
        case false:
          data.speed > 0 ? (status = 'tow') : ''
          data.speed == 0 ? (status = 'stop') : ''
          break
      }
    } else if (type == 'flex') {
      switch (true) {
        case data.speed > MIN_SPEED_THING_FLEX:
          //En movimiento
          status = 'moving'
          break
        case data.speed == MIN_SPEED_THING_FLEX:
          //Detenido
          status = 'stop'
          break
      }
    }

    return status
  },
  getThingSubType(thing) {
    let subType = ''
    let icon = ''

    switch (thing) {
      case 'truck':
        subType = i18n.t('general.labels.things.subType.truck')
        icon = 'truck'
        break
      case 'car':
        subType = i18n.t('general.labels.things.subType.car')
        icon = 'car'
        break
      case 'motorcycle':
        subType = i18n.t('general.labels.things.subType.motorcycle')
        icon = 'motorcycle'
        break
      case 'crane':
        subType = i18n.t('general.labels.things.subType.crane')
        icon = 'crane'
        break
      case 'heavy duty':
        subType = i18n.t('general.labels.things.subType.heavyDuty')
        icon = 'heavy_duty'
        break
      case 'van':
        subType = i18n.t('general.labels.things.subType.van')
        icon = 'van'
        break
      case 'flex':
        subType = i18n.t('general.labels.things.subType.flex')
        icon = 'bag'
        break
      default:
        // TODO --> cambiar el icono default de la tabla por algo generico
        subType = i18n.t('general.labels.things.subType.truck')
        icon = 'bag'
        break
    }
    return { subType, icon }
  },
  getThingIcon(marker, showEntityType = false) {
    const status = marker.status
    const heading = marker.heading
    const type = marker.type
    const subType = marker.subType
    let iconName

    const folder = showEntityType ? `${type}/${subType}` : 'generic'
    switch (folder) {
      case 'generic':
        if (status == 'on' || status == 'stop')
          iconName = `marker-circle-${status}`
        else if (heading != '')
          // Los flex no envían rumbo por eso necesitamos saber si el heading viene vacío
          // para armar el nombre del ícono correctamente
          iconName = `marker-circle-${status}-${heading}`
        else iconName = `marker-circle-on`
        break

      default:
        if (status == 'on' || status == 'stop')
          iconName = `marker-${subType}-${status}`
        else if (heading != '')
          iconName = `marker-${subType}-${status}-${heading}`
        else iconName = `marker-${subType}-${status}`
        break
    }

    // var images = require.context('@/assets/headings', true, /\.svg$/)
    return images(`./${folder}/${iconName}.svg`)
  },
  getThingHeading(heading) {
    if (typeof heading != 'number') {
      return ''
    }
    const cardinals = ['N', 'NW', 'W', 'SW', 'S', 'SE', 'E', 'NE']
    const position =
      Math.round((heading %= 360) < 0 ? heading + 360 : heading / 45) % 8
    const thingCardinal = cardinals[position]
    return i18n.t(`general.labels.heading.short.${thingCardinal}`)
  },
  //GetThingLocation -> esper un Array de THINGS, luego forma los objetos necesarios para hacer el CALL correspondiente para la GeoReferencia
  getThingLocation(things) {
    const connection = store.getters['authState/connection']
    const args = []
    const kwArgs = connectionService.createkwArgs()
    const options = {}

    things.map(thing => {
      const index = things.indexOf(thing)
      const latitude = thing.position.lat
      const longitude = thing.position.lng

      const geoLocationThing = { index, latitude, longitude }
      args.push(geoLocationThing)
    })
    const response = connection.session
      .call(GEOCODING_REVERSE_URI, args, kwArgs, options)
      .then(
        res => {
          return res
        },
        wampError => {
          console.log(wampError)
        }
      )
      .catch(err => {
        console.log('err')
        console.log(err)
      })

    return response
  },
  getThingLabel(label) {
    if (label.length > 12) {
      const formatedLabel = label.slice(0, 10) + '...'
      return formatedLabel
    } else {
      return label
    }
  },
  getThingId(thing) {
    const input = thing
    const fields = input.id.split(':')
    const thingId = fields[3]
    return thingId
  },
  getAccountId(thing) {
    const input = thing
    const fields = input.account_id.split(':')
    const accountId = fields[2]
    return accountId
  },

  getThingAgents(thing) {
    const agents = thing.agents
    const parseAgents = []
    agents.map(agent => {
      const fields = agent.split(':')
      parseAgents.push(fields[2])
    })
    return parseAgents
  },
  getThingServiceSolution(thing) {
    if (thing.config.hasOwnProperty('service_plan')) {
      const solution = thing.config.service_plan.name
      return solution
    } else return '-'
  },
  getThingServiceState(thing) {
    let strToReturn
    if (thing.config.hasOwnProperty('service_plan')) {
      const state = thing.config.service_plan.status
      switch (state) {
        case 'active':
          strToReturn = i18n.t(
            'fleet_management.entities.entities_table.labels.data_table_status_active'
          )
          break
        case 'suspended':
          strToReturn = i18n.t(
            'fleet_management.entities.entities_table.labels.data_table_status_suspended'
          )
          break
        default:
          break
      }
    } else strToReturn = '-'
    return strToReturn
  },
  getThingCreated(thing) {
    const created = dayjs(thing.created_timestamp).format('DD/MM/YYYY')
    return created
  },

  updateThingName(id, value) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [id, { info: { label: value } }]
      const kwArgs = connectionService.createkwArgs()
      const options = {}

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      // thingsListRace is a async function that fetch the person list
      const p2 = new Promise((resolve, reject) => {
        connection.session.call(THING_UPDATE_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getThingServiceList(thing) {
    // Compruebo que haya servicios en el thing y los listo
    if (thing.config.hasOwnProperty('services')) {
      const services = thing.config.services
      const serviceList = []
      for (const service in services) {
        if (services[service].status == 'active') {
          // Aqui se da formato a la lista de servicios activos previamente filtrados
          serviceList.push(Object.assign({ name: service }, services[service]))
        }
      }
      return serviceList
    } else return '-'
  },
  getThingServiceName(service) {
    let name
    switch (service) {
      case 'mrn:service:live_tracking':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_live_tracking'
        )
        break
      case 'mrn:service:gps_recovery':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_gps_recovery'
        )
        break
      case 'mrn:service:vlu_recovery':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_vlu_recovery'
        )
        break
      case 'mrn:service:gps_roaming':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_gps_roaming'
        )
        break
      case 'mrn:service:dual_sim_uy':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_dual_sim_uy'
        )
        break
      case 'mrn:service:dual_sim_cl':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_dual_sim_cl'
        )
        break
      case 'mrn:service:dual_sim_br':
        name = i18n.t(
          'fleet_management.entities.entity_info.labels.card_field_service_dual_sim_br'
        )
        break

      default:
        name = '-'
        break
    }
    return name
  },
  //ERRORS
  getErrorMessageByCode(code) {
    let strToReturn
    switch (code) {
      case 'com.magenta.error.internal_error':
        strToReturn = i18n.t(
          'general.snackbarComponent.errors.default_error_msje'
        )
        break

      default:
        strToReturn = i18n.t(
          'general.snackbarComponent.errors.default_error_msje'
        )
        break
    }
    return strToReturn
  }
}
